import NumberAnimator from './NumberAnimator'

export default NumberAnimator
